import { Task, TASK_TYPES } from '../../model/task-list/task';
import { SubProjectTask } from '../../model/task-list/subproject-task';
import {
  SubmitEntry,
  SubmitType
} from '../../services/placer-offline-changes/placer-submit.service';
import { CollectionHelper } from '../collection-helper';
import {
  SubmitInProgressEntry,
  SubmitInProgressType
} from 'src/app/services/placer-offline-changes/submit-event.service';
import {
  TaskSubmitEntry,
  TaskSubmitType
} from 'src/app/services/placer-offline-changes/task/submit/placer-task-submit.service';

export default class SubmitQueueHelper {
  private constructor() {}

  // TODO generalize this set of functions once OtherTask completion is implemented
  public static processSubmitInfo(
    tasks: Task[],
    inProgressEntries: SubmitInProgressEntry[],
    submitEntries: SubmitEntry[],
    taskSubmitEntries: TaskSubmitEntry[]
  ): void {
    if (CollectionHelper.isPopulated(tasks)) {
      tasks.forEach(t => {
        t.submitInProgress = this.evaluateTaskInProgress(t, inProgressEntries);
        t.submitQueued =
          t.type === TASK_TYPES.SUB_PROJECT_TASK
            ? this.evaluateSubProjectQueued(t.subProject.id, submitEntries)
            : this.evaluateTaskQueued(t, taskSubmitEntries);
      });
    }
  }

  public static processSubmitInProgress(
    tasks: Task[],
    inProgressEntries: SubmitInProgressEntry[]
  ): void {
    if (CollectionHelper.isPopulated(tasks)) {
      tasks.forEach(t => {
        t.submitInProgress = this.evaluateTaskInProgress(t, inProgressEntries);
      });
    }
  }

  public static processSubmitQueued(
    tasks: Task[],
    submitEntries: SubmitEntry[],
    taskSubmitEntries: TaskSubmitEntry[]
  ): void {
    if (CollectionHelper.isPopulated(tasks)) {
      tasks.forEach(t => {
        t.submitQueued =
          t.type === TASK_TYPES.SUB_PROJECT_TASK
            ? this.evaluateSubProjectQueued(t.subProject.id, submitEntries)
            : this.evaluateTaskQueued(t, taskSubmitEntries);
      });
    }
  }

  public static evaluateTaskInProgress(
    task: Task,
    inProgressEntries: SubmitInProgressEntry[]
  ): boolean {
    return this.evaluateSubmittableInProgress(
      this.getToCheckId(task),
      inProgressEntries,
      this.getToCheckType(task)
    );
  }

  private static getToCheckId(task: Task): number {
    return task.type === TASK_TYPES.SUB_PROJECT_TASK
      ? (<SubProjectTask>task).subProject.id
      : task.id;
  }

  private static getToCheckType(task: Task): SubmitInProgressType {
    switch (task.type) {
      case TASK_TYPES.SUB_PROJECT_TASK:
        return SubmitInProgressType.SUB_PROJECT;
      case TASK_TYPES.LOAD_TASK:
      case TASK_TYPES.OTHER_TASK:
        return SubmitInProgressType.TASK;
      default:
        throw new Error(`task type not recognized: ${task.type}`);
    }
  }

  public static evaluateSubProjectInProgress(
    subProjectId: number,
    inProgressEntries: SubmitInProgressEntry[]
  ) {
    return this.evaluateSubmittableInProgress(
      subProjectId,
      inProgressEntries,
      SubmitInProgressType.SUB_PROJECT
    );
  }

  public static evaluateSubmittableInProgress(
    id: number,
    inProgressEntries: SubmitInProgressEntry[],
    type: SubmitInProgressType
  ): boolean {
    return (
      CollectionHelper.isPopulated(inProgressEntries) &&
      inProgressEntries.some(e => e.id === id.toString() && e.type === type)
    );
  }

  public static evaluateTaskQueued(
    task: Task,
    submitEntries: TaskSubmitEntry[]
  ): boolean {
    return (
      CollectionHelper.isPopulated(submitEntries) &&
      submitEntries.some(
        e => e.taskId === task.id && e.submitType === TaskSubmitType.FULL
      )
    );
  }

  public static evaluateSubProjectQueued(
    subProjectId: number,
    submitEntries: SubmitEntry[]
  ): boolean {
    return (
      CollectionHelper.isPopulated(submitEntries) &&
      submitEntries.some(
        e =>
          e.subProjectId === subProjectId.toString() &&
          e.submitType === SubmitType.Full
      )
    );
  }
}
